

//This file is generated from c# do not modify, any changes will be overridden when re-generated.

    
export enum SystemRoleType {
  
  JobFunction = 'Job Function',
  Task = 'Task',
  TaskGroup = 'Task Group'
}



// WEBPACK FOOTER //
// ./src/app/security/models/SystemRoleType.ts